import React from "react";
import Queue from "nq-js";
import { dialog } from "../../nq-component";
import click from "../../click";

const defaultProps = {
  height: "250px",
};

function FileInput({ object, onChange, saveFile, disabled }) {
  const [progress, setProgress] = React.useState(0);
  const [fileName, setFileName] = React.useState(
    object ? extractFileName(object) : null
  );
  const [fileUrl, setFileUrl] = React.useState(object || null);
  const printRef = React.useRef();
  const [errorMessage, setErrorMessage] = React.useState("");

  React.useEffect(() => {
    if (object) {
      setFileName(extractFileName(object));
      setFileUrl(object);
    }
  }, [object]);

  function extractFileName(url) {
    if (!url) return null;
    const fullFileName = url.split("/").pop();
    const parts = fullFileName.split("_");
    return parts.length > 1 ? parts.slice(1).join("_") : fullFileName;
  }

  function readFile(file) {
    setFileName(file.name);
  }

  function onFileSelected(file) {
    if (!validateFile(file)) return;

    readFile(file);
    const options = {
      progress: (value) => setProgress(value * 100),
    };
    saveFile
      .execute(file, options)
      .then((result) => {
        setFileUrl(result.url);
        setProgress(0);
        onChange(result.url);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  function onClickBrowse() {
    if (disabled) return;
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "*";
    input.onchange = (e) => {
      const [file] = e.target.files;
      file && onFileSelected(file);
    };
    click(input);
  }

  function validateFile(file) {
    // const maxFileSize = 5 * 1024 * 1024;
    // console.log(maxFileSize);
    const allowedTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/png",
      "image/jpg",
    ];

    if (!file) {
      setErrorMessage("No file selected.");
      setTimeout(() => setErrorMessage(""), 3000);
      return false;
    }

    if (!allowedTypes.includes(file.type)) {
      setErrorMessage("Only PDF, DOCX, JPEG, PNG, or JPG files are allowed.");
      setTimeout(() => setErrorMessage(""), 3000);
      return false;
    }

    // if (file.size > maxFileSize) {
    //   setErrorMessage("Image size must not exceed 5 MB.");
    //   setTimeout(() => setErrorMessage(""), 3000);
    //   return false;
    // }

    setErrorMessage("");
    return true;
  }

  function viewFile() {
    window.open(fileUrl, "_blank");
  }

  return (
    <div
      className="d-flex align-items-center flex-column position-relative"
      style={{ width: "210px", height: "55px" }}
    >
      <div
        className="d-flex align-items-center justify-content-between"
        onClick={onClickBrowse}
        style={{
          width: "100%",
          height: "55px",
          border: "2px dashed red",
          cursor: disabled ? "not-allowed" : "pointer",
          fontSize: "14px",
          fontWeight: "500",
          borderRadius: "6px",
          backgroundColor: disabled ? "#f8f9fa" : "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="d-flex justify-content-between align-items-center text-truncate">
          <i
            className="bi bi-upload m-3"
            style={{ color: "red", fontSize: "18px" }}
          ></i>
          <span className="text-truncate" title={fileName || "Upload"}>
            {fileName || "Upload"}
          </span>
        </div>

        {fileUrl && (
          <button
            className="btn btn-sm ms-2 me-2"
            style={{ backgroundColor: "#D18237", color: "#fff" }}
            onClick={viewFile}
          >
            View
          </button>
        )}
      </div>
      {progress > 0 && (
        <div className="ms-3">
          <p className="m-0">Uploading: {progress.toFixed(0)}%</p>
        </div>
      )}
      {errorMessage && (
        <div
          style={{
            left: "105%",
            top: "50%",
            padding: "8px 12px",
            backgroundColor: "#f8d7da",
            transform: "translateY(-50%)",
            color: "#721c24",
            zIndex: 10,
            position: "absolute",
            border: "1px solid #f5c6cb",
            borderRadius: "5px",
            fontSize: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
}

FileInput.defaultProps = defaultProps;
export default FileInput;
